import { render, staticRenderFns } from "./DataOverride.vue?vue&type=template&id=446fd7af"
import script from "./DataOverride.vue?vue&type=script&lang=ts"
export * from "./DataOverride.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports